import React from 'react';
import { motion } from 'framer-motion';
import { useAuth } from '../contexts/AuthContext';
import { logout } from '../services/authService';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';

const Dashboard = () => {
    const { currentUser } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate('/');
    };

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1,
            },
        },
    };

    const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1,
            transition: {
                type: 'spring',
                stiffness: 300,
                damping: 24,
            },
        },
    };

    return (
        <div className="dashboard-container">
            <motion.div
                className="dashboard-content"
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                <motion.div className="welcome-card" variants={itemVariants}>
                    <motion.div
                        className="welcome-icon"
                        animate={{
                            scale: [1, 1.2, 1],
                            rotate: [0, 10, -10, 0],
                        }}
                        transition={{
                            duration: 2,
                            repeat: Infinity,
                            repeatDelay: 3,
                        }}
                    >
                        🎉
                    </motion.div>
                    <h1>Welcome to Your Dashboard!</h1>
                    <p className="user-email">{currentUser?.email}</p>
                </motion.div>

                <motion.div className="dashboard-grid" variants={itemVariants}>
                    <motion.div
                        className="dashboard-card"
                        whileHover={{ scale: 1.05, y: -5 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        <div className="card-icon">📊</div>
                        <h3>Analytics</h3>
                        <p>View your statistics and insights</p>
                    </motion.div>

                    <motion.div
                        className="dashboard-card"
                        whileHover={{ scale: 1.05, y: -5 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        <div className="card-icon">⚙️</div>
                        <h3>Settings</h3>
                        <p>Manage your account preferences</p>
                    </motion.div>

                    <motion.div
                        className="dashboard-card"
                        whileHover={{ scale: 1.05, y: -5 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        <div className="card-icon">📁</div>
                        <h3>Projects</h3>
                        <p>Access your saved projects</p>
                    </motion.div>

                    <motion.div
                        className="dashboard-card"
                        whileHover={{ scale: 1.05, y: -5 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        <div className="card-icon">👥</div>
                        <h3>Team</h3>
                        <p>Collaborate with your team</p>
                    </motion.div>
                </motion.div>

                <motion.button
                    className="logout-button"
                    onClick={handleLogout}
                    variants={itemVariants}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                >
                    Sign Out
                </motion.button>
            </motion.div>
        </div>
    );
};

export default Dashboard;
